import { TableOrientation } from './Table.types';

export interface TableCellRole {
  role: 'td' | 'th';
  align: 'left' | 'right' | 'center';
}

const ORIENTATIONS: readonly TableOrientation[] = ['top', 'left', 'crossTable'];

const isHeaderCell = (orientation: TableOrientation, rowIndex: number, columnIndex: number) => {
  switch (orientation) {
    case 'top':
      return rowIndex === 0;
    case 'left':
      return columnIndex === 0;
    case 'crossTable':
      return columnIndex === 0 || rowIndex === 0;
    default:
      return false;
  }
};

// Alignment applies only to a recognised orientation: an unexpected `orientation` string leaves
// every cell a left-aligned <td>, which un-migrated CMS content relies on.
export const tableCellRole = (orientation: TableOrientation, rowIndex: number, columnIndex: number): TableCellRole => ({
  role: isHeaderCell(orientation, rowIndex, columnIndex) ? 'th' : 'td',
  align: ORIENTATIONS.includes(orientation) && columnIndex > 0 ? 'right' : 'left',
});
